<template>
    <div>
        <div class="bar" id="barId"></div>
        <div class="top">
            <div class="topText1">通用流量</div>
            <div class="topText2">按需使用，随用随充，支持浏览与调用同类别下的所有图源<br>适合根据需求灵活使用图源的探索型用户</div>
            <img src="../../../assets/dataPack/purchaseData/top图.png" alt="" class="topImg1">
            <div class="topBtn1" @click="goToPurchase">前往购买</div>
            <div class="topBtn2" @click="goToPricing">查看定价</div>
        </div>
        <div class="block1">
            <div class="block1Ctn">
                <div class="block1Text1">高分辨率卫星影像高频次更新，灵活浏览自由调用</div>
                <div class="block1Ctn1">
                    <img src="../../../assets/dataPack/purchaseData/样例1.png" alt="" class="block1Img1">
                    <div class="block1Text2">全域范围，无界触达</div>
                    <div class="block1Text3">全国陆域全覆盖，从国内到海外，一“包”畅行无阻</div>
                </div>
                <div class="block1Ctn1">
                    <img src="../../../assets/dataPack/purchaseData/样例2.png" alt="" class="block1Img2">
                    <div class="block1Text4">现势历史，时空回溯</div>
                    <div class="block1Text5">自由调用历史影像库，动态监测地表变迁<br>见微知著，赋能规划决策</div>
                </div>
                <div class="block1Ctn1">
                    <img src="../../../assets/dataPack/purchaseData/样例3.png" alt="" class="block1Img1">
                    <div class="block1Text2">灵活便捷，指哪打哪</div>
                    <div class="block1Text3" style="width: 272px;">即可全国畅览，也可圈选重点关注区域<br>避免冗余流量消耗，精准投向价值目标</div>
                </div>
                <div class="block1Ctn1">
                    <img src="../../../assets/dataPack/purchaseData/样例4.png" alt="" class="block1Img2">
                    <div class="block1Text4">海量数据，为我所用</div>
                    <div class="block1Text5" style="width: 405px;left: 71px;">海量影像资源10分钟便捷接入企业自有业务系统<br>或快速调用至ArcGIS、Qgis、奥维互动地图等第三方平台</div>
                </div>
            </div>
        </div>
        <div class="block2" id="price-section">
            <div class="block2Text1">为您推荐流量套餐</div>
            <div class="block2Ctn1">
                <div class="block2Text2">基础流量</div>
                <div class="block2Text3">仅支持浏览与调用基础图源</div>
                <div class="block2Text4">￥0.003元/次</div>
                <div class="block2Text5">起</div>
                <div class="block2Text6">支持按照10万次，100万次，1000万次购买</div>
                <div class="block2Btn1" @click="$router.push('/GeneralTraffic/purchaseData')">立即购买</div>
                <div class="block2Btn2" @click="$router.push('/onlineService/Home')">购买咨询</div>
                <div class="block2Line"></div>
                <div class="block2Text7">支持浏览调用基础图源</div>
                <img src="../../../assets/dataPack/purchaseData/查看列表.png" alt="" class="block2Icon2">
                <div class="block2Text8" @click="goToRsManageSourceList">查看图源列表</div>
                <img src="../../../assets/dataPack/purchaseData/对号灰.png" alt="" class="block2Icon1">
                <img src="../../../assets/dataPack/purchaseData/对号灰.png" alt="" style="top: 410px;" class="block2Icon1">
                <img src="../../../assets/dataPack/purchaseData/对号灰.png" alt="" style="top: 450px;" class="block2Icon1">
                <!-- <img src="../../../assets/dataPack/purchaseData/对号灰.png" alt="" style="top: 490px;" class="block2Icon1">
                <img src="../../../assets/dataPack/purchaseData/对号灰.png" alt="" style="top: 530px;" class="block2Icon1"> -->
                <div class="block2Text9">全国年度一张图系列（2020-2024年全国高质量一张图）</div>
                <div class="block2Text9" style="top: 402px;">全国季度一张图系列（2023-2025年6月，持续更新中）</div>
                <div class="block2Text9" style="top: 442px;">全球一张图基础版系列（2021-2022年全球一张图）</div>
                <!-- <div class="block2Text9" style="top: 482px;">全国半年精选图系列（已更新至2024年下半年）</div>
                <div class="block2Text9" style="top: 522px;">全国一张图基础版系列（2020-2022年全球一张图）</div>  -->
            </div>
            <div class="block2Ctn1" style="left: calc(50% + 12px);">
                <div class="block2Text2">高级流量</div>
                <div class="block2Text3">畅享所有高级图源和基础图源</div>
                <div class="block2Text4">￥0.13元/次</div>
                <div class="block2Text5" style="left: 285px;">起</div>
                <div class="block2Text6">支持按照1万次，10万次，100万次购买</div>
                <div class="block2Btn1" @click="$router.push({ path: '/GeneralTraffic/purchaseData', query: { tier: 'premium' } })">立即购买</div>
                <div class="block2Btn2" @click="$router.push('/onlineService/Home')">购买咨询</div>
                <div class="block2Line"></div>
                <div class="block2Text7">支持浏览调用基础图源，以及高级图源</div>
                <img src="../../../assets/dataPack/purchaseData/查看列表.png" alt="" class="block2Icon2">
                <div class="block2Text8" @click="goToRsManageSourceListPremium">查看图源列表</div>
                <img src="../../../assets/dataPack/purchaseData/对号灰.png" alt="" class="block2Icon1">
                <img src="../../../assets/dataPack/purchaseData/对号灰.png" alt="" style="top: 410px;" class="block2Icon1">
                <!-- <img src="../../../assets/dataPack/purchaseData/对号灰.png" alt="" style="top: 450px;" class="block2Icon1">
                <img src="../../../assets/dataPack/purchaseData/对号灰.png" alt="" style="top: 490px;" class="block2Icon1"> -->
                <div class="block2Text9">全国季度一张图系列（已更新至2026年第三季度）</div>
                <div class="block2Text9" style="top: 402px;">全球一张图高级版系列（2023年全球一张图，不定期更新）</div>
                <!-- <div class="block2Text9" style="top: 442px;">全国半年精选图系列（已更新至2025年下半年）</div>
                <div class="block2Text9" style="top: 482px;">全球一张图高级版系列（2023年全球一张图，不定期更新）</div> -->
                <img src="../../../assets/dataPack/purchaseData/新.png" alt="" class="block2Icon3">
                <!-- <img src="../../../assets/dataPack/purchaseData/新.png" alt="" style="top: 406px;left: 453px;" class="block2Icon3">
                <img src="../../../assets/dataPack/purchaseData/新.png" alt="" style="top: 446px;left: 411px;" class="block2Icon3"> -->
            </div>
        </div>
    </div>

</template>
<script>
import {rootUrl} from '@/globalConfig'
export default {
    data() {
        return {

        }
    },
    mounted(){
        document.getElementById("barId").scrollIntoView({ behavior: "instant" });
        this.scrollToPriceSectionIfNeeded();
    },
    watch:{
        '$route.hash'() {
            this.scrollToPriceSectionIfNeeded();
        },
    },
    created(){
    },
    computed: {},
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        checkAndHandleAuthentication(){
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(!loginUserId){
            this.jumpWithPermission('仅登录','/Login','/rskit/')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/rskit/')
          }
          return true;
        },
        scrollToPriceSectionIfNeeded() {
            if (this.$route.hash !== '#price-section') return;
            this.$nextTick(() => {
                const target = document.getElementById('price-section');
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            });
        },
        goToPurchase() {
            const loginUserId = localStorage.getItem('userId');
            const authentication = localStorage.getItem('authentication');
            const purchaseReturnUrl = '/rskit/GeneralTraffic/purchaseData';
            if (!loginUserId) {
                this.jumpWithPermission('仅登录', '/Login', purchaseReturnUrl);
                return;
            }
            if (authentication !== '0') {
                this.jumpWithPermission('仅实名', '/Authentication', purchaseReturnUrl);
                return;
            }
            this.$router.push('/GeneralTraffic/purchaseData');
        },
        goToRsManageSourceList() {
            this.$router
                .push({
                    path: '/rsManage',
                    hash: '#source-list-section',
                    query: { sourceTab: '1' },
                })
                .catch(() => {});
        },
        goToRsManageSourceListPremium() {
            this.$router
                .push({
                    path: '/rsManage',
                    hash: '#source-list-section',
                    query: { sourceTab: '2' },
                })
                .catch(() => {});
        },
        /** 避免同页同 hash 时 router.push 被判定为重复导航，watch 不触发导致不滚动 */
        goToPricing() {
            const loc = { path: '/GeneralTraffic/Home', hash: '#price-section' };
            if (this.$route.path === loc.path && this.$route.hash === loc.hash) {
                this.scrollToPriceSectionIfNeeded();
                return;
            }
            this.$router.push(loc).catch(() => {
                this.scrollToPriceSectionIfNeeded();
            });
        },
    }
}
</script>
<style scoped>
.bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.top{
    position: relative;
    width: 100vw;
    height: 400px;
    background: linear-gradient(135deg, rgba(105, 192, 255, 0.6) 0%,  0%,  rgba(133, 203, 255, 0.6)  50%, rgba(255, 255, 255, 0.6) 100%);
    overflow: hidden;
}
.topText1{
    position: relative;
    margin-top: 80px;
    margin-left: calc(50% - 588px);
    width: auto;
    height: 46px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 38px;
    color: rgba(0,0,0,0.85);
    line-height: 46px;
}
.topText2{
    position: relative;
    margin-top: 40px;
    margin-left: calc(50% - 588px);
    width: auto;
    height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #1F1F1F;
    line-height: 28px;
}
.topBtn1{
    position: absolute;
    top: 288px;
    left:calc(50% - 588px);
    width: 176px;
    height: 48px;
    background: #1890FF;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
}
.topBtn2{
    position: absolute;
    top: 288px;
    left:calc(50% - 388px);
    width: 176px;
    height: 48px;
    border-radius: 8px;
    border: 1px solid #8C8C8C;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
}
.block1{
    position: relative;
    width: 100vw;
    height: 1886px;
    overflow: hidden;
    background-image: url("../../../assets/dataPack/AnnualPurchase/大背景.png");
    background-position: center;
    background-size: cover;
}
.block1Ctn{
    position: relative;
    width: 1176px;
    height: 1706px;
    margin-top: 100px;
    overflow: hidden;
    margin-left: 50%;
    transform: translate(-50% ,0);
}
.block1Text1{
    width: 100%;
    height: 46px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 38px;
    color: rgba(0,0,0,0.85);
    line-height: 46px;
    text-align: center;
}
.block1Ctn1{
    position: relative;
    width: 100%;
    height: 332px;
    margin-top: 64px;
    margin-bottom: 36px;
}
.block1Img1{
    position: absolute;
    top: 0;
    left: 0;
    width: 584px;
}
.block1Text2{
    position: absolute;
    top: 100px;
    left: 700px;
    width: auto;
    height: 38px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 30px;
    color: rgba(0,0,0,0.85);
    line-height: 38px;
}
.block1Text3{
    position: absolute;
    top: 178px;
    left: 700px;
    width: auto;
    height:  auto;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 24px;
}
.block1Img2{
    position: absolute;
    width: 584px;
    left: 600px;
}
.block1Text4{
    position: absolute;
    top: 100px;
    left:206px;
    width: auto;
    height: 38px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 30px;
    color: rgba(0,0,0,0.85);
    line-height: 38px;
}
.block1Text5{
    position: absolute;
    top: 178px;
    left: 188px;
    width: 288px;
    height: auto;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 24px;
    text-align: right;
}
.block2{
    position: relative;
    width: 100vw;
    height: 820px;
    background: #F7FAFD;
    overflow: hidden;
}
.block2Text1{
    position: relative;
    margin-top: 100px;
    width: 100%;
    height: 46px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 38px;
    color: rgba(0,0,0,0.85);
    line-height: 46px;
    text-align: center;
}
.block2Ctn1{
    position: absolute;
    top: 210px;
    left: calc(50% - 588px);
    width: 576px;
    height: 520px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 32px;
}
.block2Text2{
    position: absolute;
    top: 40px;
    left: 40px;
    width: auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
}
.block2Text3{
    position: absolute;
    top: 44px;
    left: 152px;
    width: auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 24px;
}
.block2Text4{
    position: absolute;
    top: 96px;
    left: 40px;
    width: auto;
    height: 59px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 42px;
    color: rgba(0,0,0,0.85);
    line-height: 59px;
}
.block2Text5{
    position: absolute;
    top: 125px;
    left: 310px;
    width: 284px;
    height: auto;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
}
.block2Text6{
    position: absolute;
    top: 171px;
    left: 40px;
    width: auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 24px;
}
.block2Btn1{
    position: absolute;
    top: 219px;
    left: 40px;
    width: 184px;
    height: 54px;
    background: #1890FF;
    border-radius: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 54px;
    text-align: center;
    cursor: pointer;
}
.block2Btn2{
    position: absolute;
    top: 219px;
    left: 264px;
    width: 184px;
    height: 54px;
    border-radius: 24px;
    border: 1px solid #1890FF;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #1890FF;
    line-height: 54px;
    text-align: center;
    cursor: pointer;
}
.block2Line{
    position: absolute;
    width: 496px;
    height: 1px;
    border-top: 1px solid #979797;
    top: 297px;
    left: 40px;
}
.block2Text7{
    position: absolute;
    top: 322px;
    left: 40px;
    width: auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 24px;
}
.block2Text8{
    position: absolute;
    top: 322px;
    left: 440px;
    width:auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1890FF;
    line-height: 24px;
    cursor: pointer;
}
.block2Text9{
    position: absolute;
    top: 362px;
    left: 68px;
    width:auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 24px;
}
.topImg1{
    position: absolute;
    left: calc(50% + 60px);
    top: 40px;
    width: 480px;
}
.block2Icon1{
    position: absolute;
    top: 370px;
    left: 40px;
    width: 12px;
}
.block2Icon2{
    position: absolute;
    top: 326px;
    left: 416px;
    width: 16px;
}
.block2Icon3{
    position: absolute;
    top: 366px;
    left: 427px;
    width: 32px;
}
</style>
